/* eslint-disable no-undef */
import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const AuthPage = props => {
  const { title, children, ...rest } = props;

  return (
    <div {...rest}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
};

AuthPage.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string
};

export default AuthPage;
